"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const scale_1 = require("../../../utils/scale");
const styles_1 = __importDefault(require("./styles"));
const DeleteAccountThreeScreen = (props) => {
    return (react_1.default.createElement(react_native_1.View, { style: {
            flex: 1,
            backgroundColor: '#F7F7F7',
            justifyContent: 'space-between',
        } },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, titleStyle: {
                    alignSelf: 'center',
                }, title: 'アカウント削除', styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, leftIcon: react_1.default.createElement(BackHeader_1.default, null) }),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                react_1.default.createElement(react_native_1.View, { style: { flexDirection: 'row' } },
                    react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(16),
                            lineHeight: (0, scale_1.moderateScale)(24),
                            color: '#292A33',
                            fontWeight: '300',
                            paddingLeft: (0, scale_1.scale)(8),
                        } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u3092\u884C\u3046\u524D\u306B")),
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(12),
                    } }, "\u30E1\u30EB\u30DE\u30AC\u30FB\u901A\u77E5\u306E\u8A2D\u5B9A\u5909\u66F4"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        paddingTop: (0, scale_1.scale)(8),
                    } }, "\u9000\u4F1A\u306E\u4EE3\u308F\u308A\u306B\u3001\u3053\u306E\u753B\u9762\u304B\u3089\u30E1\u30EB\u30DE\u30AC\u3084\u901A\u77E5\u3092\u5168\u3066OFF\u306B\u3059\u308B\u3053\u3068\u3082\u3067\u304D\u307E\u3059\u3002"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                    } }, "\u8A2D\u5B9A\u306E\u5909\u66F4\u3092\u884C\u3063\u3066\u304F\u3060\u3055\u3044\u3002"),
                react_1.default.createElement(components_1.LinearButton, { containerStyle: { marginTop: (0, scale_1.scale)(32) }, fontWeight: "600", title: "\u5404\u7A2E\u901A\u77E5\u8A2D\u5B9A\u3078", onPress: () => (0, rootNavigation_1.navigate)(Routes_1.default.NOTIFY_SETTING, { type: 'pushnoti' }) }),
                react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => {
                        props.navigation.navigate(Routes_1.default.DELETE_ACCOUNT_FOUR_SCREEN);
                    } },
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                            fontSize: (0, scale_1.moderateScale)(14),
                            lineHeight: (0, scale_1.moderateScale)(21),
                            color: '#007AFF',
                            marginTop: (0, scale_1.scale)(20),
                            textAlign: 'center',
                        } }, "\u30A2\u30AB\u30A6\u30F3\u30C8\u524A\u9664\u3092\u884C\u3046"))))));
};
exports.default = DeleteAccountThreeScreen;
